module.exports = __webpack_public_path__ + "static/media/fullscreen-icon.8d18a0ed.svg";